import { Component } from '@angular/core';
import {  NavController, NavParams, LoadingController, ToastController, MenuController } from 'ionic-angular';
import { CategoriaNoticiasYOfertas } from '../../models/categoria.noticiasyofertas.model';
import { Consultas } from '../../providers/consultas';
import { BuscadorPage } from '../buscador/buscador';
import { NoticiasGeneralesPage } from '../noticias-generales/noticias-generales';

/**
 * Generated class for the CategoriaNoticiasGeneralesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-categoria-noticias-generales',
  templateUrl: 'categoria-noticias-generales.html',
})
export class CategoriaNoticiasGeneralesPage {
  public categorias:Array<CategoriaNoticiasYOfertas>;
  public loader:any;
  public idCiudad:number;
  public nombrePueblo:string;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public loadingCtrl: LoadingController,public consultas: Consultas,
    public toastCtrl: ToastController,public menuCtrl:MenuController ) {
    this.nombrePueblo = navParams.get("nombrePueblo");
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CategoriaNoticiasPage');
  }
 goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }
  ngOnInit(){
    this.loader = this.loadingCtrl.create();
    //Muestro el cargador mientras se cargan los productos
    this.loader.present().then(()=>{
        this.consultas.getCategoriasNoticiasGenerales().subscribe(x=>{
            this.categorias = x;
            this.loader.dismiss();
          },error=>{
            console.error(error);
            this.loader.dismiss();
          }
          );
    });
  }
  goToNoticias(categoria){
    this.navCtrl.push(NoticiasGeneralesPage,{idCategoria: categoria.idCat});
  }
  toggleMenu() {
    this.menuCtrl.toggle();
  }
}



// WEBPACK FOOTER //
// ./src/pages/categoria-noticias-generales/categoria-noticias-generales.ts